import React from "react";

const cards = [
  ["01", "Complete Risk Segmentation Framework", "Complete 4-tier vulnerability scoring methodology, factor tables, tier assignment framework, and refresh protocols."],
  ["02", "Intervention Protocols", "Tier-specific engagement frameworks, escalation procedures, and implementation guidance."],
  ["03", "Communication Library", "16 email templates, 24 SMS templates, and 6 specialist phone scripts — 46 ready-to-adapt communication assets."],
  ["04", "Borrower Case Studies", "12 complete worked borrower profiles covering all four risk tiers."],
  ["05", "Implementation", "90-day deployment roadmap with phase milestones and operational task assignments."],
  ["06", "Governance", "Regulation X reference framework and fair-lending governance checklist for institutional validation."],
  ["07", "Performance Management", "Executive, Manager, and Analyst dashboard templates."],
  ["08", "Measurement", "52-week KPI tracking and institution-controlled business-case / ROI measurement model."],
  ["09", "Executive Presentation", "Internal stakeholder briefing presentation."],
  ["10", "Complete Deployment Package", "PDF + editable Word materials + presentation + implementation resources in one institutional ZIP package."],
];

const WhatYouGet = () => (
  <section id="included" className="section bg2">
    <div className="w">
      <div style={{ maxWidth: 760 }}>
        <div className="eyebrow">What You License</div>
        <h2 className="h2">What Your $4,995 Institutional License <em className="gold">Includes</em></h2>
      </div>
      <div className="get-grid">
        {cards.map((c, i) => (
          <div className="get-card" key={i}>
            <div className="get-num">{c[0]}</div>
            <h4>{c[1]}</h4>
            <p>{c[2]}</p>
          </div>
        ))}
      </div>
      <div className="anchor-statement" style={{ marginTop: "3rem" }}>
        <p>This is not a consumer booklet or general educational report. It is a <strong>complete institutional implementation resource</strong> designed to be evaluated, adapted, approved, and deployed within the institution's existing servicing environment.</p>
      </div>
    </div>
  </section>
);

export default WhatYouGet;
